// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__W-5mm","year":"Footer_year__Hmrt8","link":"Footer_link__zwxe4"};